/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from "react";
import {useHistory, withRouter} from "react-router-dom";
// import {SAVE_PERSON} from "../../../database/queries/personQueries"
import usePersistentStore from "../../../persistentStore";
import {useMutation, useQuery} from "@apollo/react-hooks";
// import {SAVE_ORGANIZATION} from "../../../database/queries/organizationQueries";
import {notify} from "../../../utils/notify";
import moment from "moment";
import {tellParentMessage, tellParentURLMessage} from "../../../utils/utils";
import {GET_ACCOUNT_BY_LINKEDIN_ID} from "../../../database/queries/accountQueries";
import {GET_CONTACT_BY_LINKEDIN_ID} from "../../../database/queries/contactQueries";

const MessageReceiver = props => {
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const [nsiSent, setNSISent] = useState(false);

    // const [savePerson, {error: savePersonError, data: savePersonData}] = useMutation(SAVE_PERSON);
    // const [saveOrganization, {
    //     error: saveOrganizationError,
    //     data: saveOrganizationData
    // }] = useMutation(SAVE_ORGANIZATION);

    const {refetch: getAccountByLinkedinIdRefetch} = useQuery(GET_ACCOUNT_BY_LINKEDIN_ID, {skip: true});

    const {refetch: getContactByLinkedinIdRefetch} = useQuery(GET_CONTACT_BY_LINKEDIN_ID, {skip: true});

    const history = useHistory();

    // useEffect(() => {
    //     if (savePersonError) {
    //         notify('messageReceiverError', 'error', savePersonError.message);
    //     }
    //     if (saveOrganizationError) {
    //         notify('messageReceiverError', 'error', saveOrganizationError.message);
    //     }
    // }, [savePersonError, saveOrganizationError]);

    useEffect(() => {
        window.addEventListener('message', handleIframeTask);
        return () => {
            window.removeEventListener('message', handleIframeTask);
        };
    });

    // useEffect(() => {
    //     if (savePersonData) {
    //         globalPersistentActions.setAppTitle(savePersonData.savePerson.displayName);
    //         globalPersistentActions.setMessage();
    //         console.log('## SVR MessageReceiver ## changing history', '/contacts/' + savePersonData.savePerson.contactId);
    //         history.push('/contacts/' + savePersonData.savePerson.contactId);
    //         notify('savePerson', 'info', 'Received contact from LinkedIn');
    //     }
    // }, [savePersonData]);
    //
    // useEffect(() => {
    //     if (saveOrganizationData) {
    //         globalPersistentActions.setAppTitle(saveOrganizationData.saveOrganization.accountName);
    //         globalPersistentActions.setMessage();
    //         console.log('## SVR MessageReceiver ## changing history', '/accounts/' + saveOrganizationData.saveOrganization.accountId);
    //         history.push('/accounts/' + saveOrganizationData.saveOrganization.accountId);
    //         notify('saveOrganization', 'info', 'Received account from LinkedIn');
    //     }
    // }, [saveOrganizationData]);

    // const saveMessage = (msg) => {
    //     const now = moment();
    //     if (msg.person) {
    //         if (globalPersistentState.lastSaved && globalPersistentState.lastSaved.id === msg.person.personLinkedinId && now.diff(globalPersistentState.lastSaved.savedTime, 'seconds') < 5) {
    //             console.log('## SVR MessageReceiver ## savePerson too soon... must be an error');
    //         } else {
    //             console.log('## SVR MessageReceiver ## changing history', '/loading');
    //             history.push('/loading');
    //             globalPersistentActions.setLastSaved({id: msg.person.personLinkedinId, savedTime: moment()});
    //             savePerson({variables: {person: msg.person}})
    //         }
    //     } else if (msg.organization) {
    //         if (globalPersistentState.lastSaved && globalPersistentState.lastSaved.id === msg.organization.organizationLinkedinId && now.diff(globalPersistentState.lastSaved.savedTime, 'seconds') < 5) {
    //             console.log('## SVR MessageReceiver ## saveOrg too soon... must be an error');
    //         } else {
    //             console.log('## SVR MessageReceiver ## changing history', '/loading');
    //             history.push('/loading');
    //             globalPersistentActions.setLastSaved({id: msg.organization.organizationLinkedinId, savedTime: moment()});
    //             saveOrganization({variables: {organization: msg.organization}})
    //         }
    //     }
    // };

    const handleIframeTask = (e) => {
        try {
            // console.log("## SVR MessageReceiver ## handleIframeTask", 'signed-in=', isSignedIn(), e.data, e.origin, JSON.stringify(e));
            if (!globalPersistentState.token && e.origin) {
                console.log("## SVR MessageReceiver ## handleIframeTask sending not-signed-in");
                if (!nsiSent) {
                    setNSISent(true);
                    tellParentURLMessage({userPreferences: 'not-signed-in'}, e.origin)
                }
            } else {
                if (e.data && (e.data.notify || e.data.popupSaveText || e.data.action)) {
                    console.log("## SVR MessageReceiver ## handleIframeTask e.data=", e.data);
                    if (e.data.notify) {
                        if (e.data.notify === 'popup closed') {
                            globalPersistentActions.setPopupQueryObj();
                        }
                    } else if (e.data.popupSaveText) {
                        globalPersistentActions.setPopupSaveText(e.data.popupSaveText);
                    } else if (e.origin && e.data.action) {
                        // if (e.data.action === 'get preferences') {
                        //     getUserPreferencesRefetch().then(preferencesRefetchResult => {
                        //         tellParentURLMessage({userPreferences: preferencesRefetchResult.data.userPreferences}, e.origin)
                        //     }).catch(e => {
                        //         console.trace(e);
                        //         tellParentURLMessage({userPreferences: 'problem getting preferences'}, e.origin)
                        //     });
                        // }
                    }
                } else if (e.data && e.data.getAccount) {
                    getAccountByLinkedinIdRefetch({accountLinkedinId: e.data.getAccount}).then(refetchResult => {
                        tellParentMessage(!refetchResult.data || !refetchResult.data.accountByLinkedinId ? {accountId: 'not found'} : {accountId: refetchResult.data.accountByLinkedinId.accountId}, globalPersistentState.popupQueryObj)
                    }).catch(e => {
                        console.trace(e);
                    });
                } else if (e.data && e.data.getContact) {
                    getContactByLinkedinIdRefetch({contactLinkedinId: e.data.getContact}).then(refetchResult => {
                        tellParentMessage(!refetchResult.data || !refetchResult.data.contactByLinkedinId ? {contactId: 'not found'} : {contactId: refetchResult.data.contactByLinkedinId.contactId}, globalPersistentState.popupQueryObj)
                    }).catch(e => {
                        console.trace(e);
                    });
                } else if (e.origin && e.origin.indexOf('linkedin') > -1) {
                    const incomingMessage = e.data;
                    globalPersistentActions.setAppTitle();
                    if (globalPersistentState.me) {
                        // saveMessage(incomingMessage);
                    } else {
                        globalPersistentActions.setMessage(incomingMessage);
                        console.log('## SVR MessageReceiver ## changing history', '/sign-in');
                        history.push('/sign-in');
                    }
                }
            }
        } catch (e) {
            tellParentURLMessage({userPreferences: 'not-signed-in'}, e.origin)
            console.trace(e);
        }
    };

    return <div style={{display: 'none'}}>@</div>
};

export default withRouter(MessageReceiver);
